import React from 'react';
import { IoChevronBack, IoChevronForward } from "react-icons/io5";

const Pagination = ({ currentPage, lastPage, onPageChange }) => {


    const renderPageNumbers = () => {
        const pages = [];
        const maxVisiblePages = 5;
        let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
        let endPage = Math.min(lastPage, startPage + maxVisiblePages - 1);

        if (endPage - startPage + 1 < maxVisiblePages) {
            startPage = Math.max(1, endPage - maxVisiblePages + 1);
        }

        for (let i = startPage; i <= endPage; i++) {
            pages.push(
                <button
                    key={i}
                    onClick={() => onPageChange(i)}
                    className={`w-8 h-8 flex items-center justify-center rounded-lg text-sm font-medium transition-colors duration-200 
                        ${currentPage === i
                            ? 'bg-[#800000] text-white'
                            : 'text-gray-600 hover:bg-gray-100 hover:text-[#800000]'
                        }`}
                >
                    {i}
                </button>
            );
        }
        return pages;
    };

    return (
        <div className="flex items-center justify-center gap-2 mt-8">
            <button
                onClick={() => onPageChange(currentPage - 1)}
                disabled={currentPage === 1}
                className={`p-2 rounded-lg transition-colors duration-200 
                    ${currentPage === 1
                        ? 'text-gray-300 cursor-not-allowed'
                        : 'text-gray-600 hover:bg-gray-100 hover:text-[#800000]'
                    }`}
            >
                <IoChevronBack size={18} />
            </button>

            <div className="flex items-center gap-1">
                {renderPageNumbers()}
            </div>

            <button
                onClick={() => onPageChange(currentPage + 1)}
                disabled={currentPage === lastPage}
                className={`p-2 rounded-lg transition-colors duration-200 
                    ${currentPage === lastPage
                        ? 'text-gray-300 cursor-not-allowed'
                        : 'text-gray-600 hover:bg-gray-100 hover:text-[#800000]'
                    }`}
            >
                <IoChevronForward size={18} />
            </button>
        </div>
    );
};

export default Pagination;
